import { PaymentOption, PaymentProviderEntry } from 'api/queries/escrow/get-payment-providers';
import { isAllowedIconUrl } from 'utils/is-allowed-icon-url';
import { getProviderLabel } from 'utils/provider-labels';

/**
 * Maps a raw icon URL to a safe value for UI consumption.
 *
 * Returns null when the URL is missing or fails allow-list validation.
 */
function normaliseIconUrl(iconUrl: string | null): string | null {
  if (!iconUrl) {
    return null;
  }

  return isAllowedIconUrl(iconUrl) ? iconUrl : null;
}

/**
 * Flattens a provider matrix into a single list of selectable payment options.
 *
 * Drivers without methods produce one driver-level option using the provider
 * label and provider icon. Drivers with methods produce one option per method
 * using method label and method icon. Input order is preserved.
 */
export function flattenProviderOptions(providers: PaymentProviderEntry[]): PaymentOption[] {
  return providers.flatMap((provider) => {
    if (0 === provider.methods.length) {
      return [
        {
          driver: provider.driver,
          iconUrl: normaliseIconUrl(provider.icon_url),
          label: getProviderLabel(provider.driver),
        },
      ];
    }

    return provider.methods.map((method) => ({
      driver: provider.driver,
      iconUrl: normaliseIconUrl(method.icon_url),
      paymentMethod: method.code,
      label: method.name,
    }));
  });
}
